exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buttons-question {\n  width: 100%; }\n\n.buttons-question__content {\n  margin: 5px auto; }\n\n.buttons-question__answers {\n  display: flex;\n  justify-content: space-evenly;\n  width: 100%; }\n\n.button-question__button {\n  margin-right: 10px; }\n\n.button-question__button:last-child {\n  margin-right: 0; }\n", ""]);

